var document = require('./_global').document;
module.exports = document && document.documentElement;



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/modules/_html.js